import { Badge, Box, List, Stack, Text } from "@repo/ui/core";
import { motion } from "framer-motion";
import { SlideTitle } from "@components/SlideTitle";
import classes from "@styles/onsite.module.css";

type Props = {
  title: string;
  subtitle?: string;
  bullets: string[];
  keyPoint?: string;
  placeholder?: boolean;
};

export function ContentSlide({ title, subtitle, bullets, keyPoint, placeholder }: Props) {
  return (
    <Box w="100%" maw={1400} px="xl">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Stack gap="xl">
          <Box>
            <SlideTitle title={title} subtitle={subtitle} />
            {placeholder && (
              <Badge color="yellow" variant="light" size="md" mt="xs">
                PLACEHOLDER
              </Badge>
            )}
          </Box>

          <List spacing="lg" size="xl" style={{ listStyleType: "none" }}>
            {bullets.map((bullet, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.3, delay: 0.2 + i * 0.1 }}
              >
                <List.Item
                  style={{
                    borderLeft: "3px solid var(--customer-accent)",
                    paddingLeft: "var(--mantine-spacing-lg)",
                    marginBottom: "var(--mantine-spacing-md)",
                  }}
                >
                  <Text size="xl" lh={1.6}>
                    {bullet}
                  </Text>
                </List.Item>
              </motion.div>
            ))}
          </List>

          {keyPoint && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.6 }}
            >
              <Box
                p="lg"
                className={classes.keyPointBox}
              >
                <Text size="xl" fw={500} style={{ color: "var(--customer-accent-light)" }}>
                  {keyPoint}
                </Text>
              </Box>
            </motion.div>
          )}
        </Stack>
      </motion.div>
    </Box>
  );
}
